import React from "react";

const ExpansionIcon = ({
 icon_url,
 width,
 cssClassList
}) => {

  return (
    icon_url &&
      <img src={icon_url} key={icon_url} alt="" className={cssClassList ? cssClassList : "ml-1"} style={{width: width}}/>
  );
};

export default ExpansionIcon;